import {createRouter, createWebHistory} from 'vue-router';
import FaqComponent from "@/components/FaqComponent.vue"; // 引入 FAQ 组件
import GuideComponent from "@/components/GuideComponent.vue"; // 引入 FAQ 组件
import TutorialComponent from '@/components/TutorialComponent.vue'; // 引入 使用教程 組件
import FeedbackComponent from "@/components/FeedbackComponent.vue"; // 引入 意見反饋 組件
const routes = [
    {
        path: '/guide',
        name: 'Guide',
        component: GuideComponent,
    },
    {
        path: '/',
        name: 'Faq',
        component: FaqComponent,
    },
    {
        path: '/tutorial',
        name: 'Tutorial',
        component: TutorialComponent,
    },
    {
        path: '/feedback',
        name: 'Feedback',
        component: FeedbackComponent
    }
    // 其他路由配置
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL || '/'),
    routes,
});

export default router;
